import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { Button } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { RelatorioContainer } from '@/shared/components/relatorios/components/relatorio-container/relatorio-container';
import { RelatorioMedicoBase } from '@/features/registro/medicos/relatorios/relatorio-medico.base';
import { RelatorioJobFacade } from '@/shared/components/relatorios/relatorio-job-base';
import { Pesquisa } from '@/shared/components/pessoa/pesquisa/pesquisa';
import { CardMedicoSelecionado } from '@/features/registro/medicos/relatorios/components/card-medico-selecionado/card-medico-selecionado';
import { FichaCadastralMedicoService } from '@/core/api/sicom-api/registro/medico/relatorios/ficha-cadastral-medico/ficha-cadastral-medico.service';
import { ReportFichaCadastralMedicoRequest, ReportFichaCadastralMedicoResponse } from '@/core/api/sicom-api/registro/medico/relatorios/ficha-cadastral-medico/ficha-cadastral-medico.model';
import { FichaCadastralMedicoJobService } from '@/core/services/ficha-cadastral-medico-job.service';
import { CanDirective } from '@/core/permissions/can.directive';

type Req = ReportFichaCadastralMedicoRequest;
type Resp = ReportFichaCadastralMedicoResponse;

@Component({
    selector: 'app-ficha-cadastral-medico',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [AsyncPipe, Button, TooltipModule, RelatorioContainer, Pesquisa, CardMedicoSelecionado, CanDirective],
    templateUrl: './ficha-cadastral-medico.html',
    styleUrl: './ficha-cadastral-medico.scss'
})
/**
 * Relatório PDF assíncrono da Ficha Cadastral do médico (nuCrm/sgUf).
 * Herda `RelatorioMedicoBase`: toda a orquestração de export/polling/download/erro e o card
 * "médico selecionado + Alterar" vêm da base; aqui só delegamos o HTTP ao service.
 */
export class ReportFichaCadastralMedicoComponent extends RelatorioMedicoBase<Req, Resp> {
    private readonly fichaService = inject(FichaCadastralMedicoService);
    readonly fichaJobService = inject(FichaCadastralMedicoJobService);

    /** Stream do job para o `app-relatorio-container` (preview/PDF) no template. */
    readonly job$ = this.fichaJobService.job$;

    protected get jobFacade(): RelatorioJobFacade {
        return this.fichaJobService;
    }

    /** Monta o request a partir do médico selecionado; retorna null (e avisa) se faltar CRM/UF. */
    protected buildRequest(): Req | null {
        return this.resolverIdentificacaoMedico('Selecione um médico (CRM/UF) antes de gerar a ficha.');
    }

    protected exportar(request: Req) {
        return this.fichaService.exportarPdf(request);
    }

    /** Limpa o job/preview corrente (a ficha não tem formulário de dados a resetar). */
    limparFormulario(): void {
        this.limparJob();
    }
}
